<template>
  <div id="page-user-add">
    <form-user-basic-info></form-user-basic-info>
  </div>
</template>

<script>
import moduleUser from "@/store/enterprise/user/moduleUser";
import FormUserBasicInfo from "./forms/FormUserBasicInfo.vue";

export default {
  components: {
    FormUserBasicInfo
  },

  /*=========================================================================================
    ライフサイクル
  ==========================================================================================*/

  created() {
    if (!moduleUser.isRegistered) {
      this.$store.registerModule("moduleUser", moduleUser);
      moduleUser.isRegistered = true;
    }
  },
  beforeDestroy() {
    if (moduleUser.isRegistered) {
      moduleUser.isRegistered = false;
      this.$store.unregisterModule("moduleUser");
    }
  }
};
</script>
